import Request from 'gd-request';


class ApiPrintToPDF {


    getContent(requestId) {
        return new Request(this, 'POST', 'export-pdf-get-content', {
            requestId: requestId
        });
    }

    exportToPDF(content, width, height, format, orientation, fitToScreen) {

        return new Request(this, 'POST', 'export/pdf-chrome', {
            userId: gd.session.me.id,
            content: content,
            width: width,
            height: height,
            format: format,
            orientation: orientation,
            scaleToFit: fitToScreen
        });

        // return new Request(this, 'POST', 'export-pdf-new', {
        //     userId: gd.session.me.id,
        //     content: content,
        //     width: width,
        //     height: height
        // });
    }

    // is it in use ?
    // printTimeline({companyId, projectId, viewId, startDate, endDate, zoom, status, timeAllocation}) {
    //     let params = {};
    //     if (companyId)      params.companyId = companyId;
    //     if (projectId)      params.projectId = projectId;
    //     if (viewId)         params.viewId = viewId;
    //     if (startDate)      params.startDate = startDate;
    //     if (endDate)        params.endDate = endDate;
    //     if (zoom)           params.zoom = zoom;
    //     if (status)         params.status = status;
    //     if (timeAllocation) params.timeAllocation = timeAllocation;
    //
    //     return new Request(this, 'POST', 'export-pdf', {
    //         appName: 'timeline',
    //         params
    //     });
    // }
}


module.exports = ApiPrintToPDF;